import type { ResetPassword } from 'models';
import { apiClient, routes } from 'common/services';

export const resetPassword = async ({ currentPassword, email, password, resetPasswordToken }: ResetPassword) => {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
  const data = {
    user: {
      current_password: currentPassword,
      email,
      password,
      reset_password_token: resetPasswordToken,
    },
  };
  /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

  return apiClient.put(routes.user.password, data, { skipAuth: true });
};
